import React from 'react';
import { Button } from 'tuui';
import { FormField } from 'taboola-ultimate-ui';
import CampaignDropdown from 'modules/campaigns/modules/creative-creator/components/CampaignsField/CreativeCreatorCampaignDropdown';
import { withIndication } from 'modules/errors';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { QRCode } from '../QRCode/QRCode';
import { useS2STestLinkGenerator } from '../WebsiteUrlTestEvents/hooks/useS2STestLinkGenerator';
import styles from './s2sTestLinkGenerator.module.scss';

const ButtonWithIndication = withIndication(Button);

export const S2STestLinkGenerator = () => {
    const { formAccount, selectedCampaign, data, pixelTesterUrl, handleGenerateClick, handleCampaignChange } =
        useS2STestLinkGenerator();

    return (
        <div className={styles['container']}>
            <FormField
                label={<FormattedMessage id="pixel.tester.s2s.select.campaign.label" defaultMessage="Campaigns" />}
                labelClass={styles['label']}
            >
                <CampaignDropdown
                    className={styles['dropdown']}
                    dropdownWrapperClassName={styles['dropdown-container']}
                    accountForCampaign={formAccount}
                    onSelectCampaign={handleCampaignChange}
                    selectedCampaigns={[selectedCampaign]}
                    placeholder={
                        <FormattedMessage id="pixel.tester.s2s.select.campaign.placeholder" defaultMessage="Select" />
                    }
                    validations={[]}
                />
            </FormField>
            <ButtonWithIndication
                disabled={!selectedCampaign}
                className={styles['test-events-button']}
                onClick={handleGenerateClick}
                indicationType="error"
                message={data?.errorMessage && <FormattedMessage id={data.errorMessage} defaultMessage="error" />}
            >
                <FormattedMessage id="pixel.tester.website.generate-qr-code.button" defaultMessage="Generate QR Code" />
            </ButtonWithIndication>
            {pixelTesterUrl && <QRCode key={pixelTesterUrl} pixelTesterUrl={pixelTesterUrl} />}
        </div>
    );
};
